<template>
  <van-field
    v-model="value"
    :maxlength="11"
    clearable
    type="number"
    label="手机号"
    size="large"
    placeholder="请输入手机号"
    @input="handleChange"
    @focus="handleFocus"
  />
</template>
<script>
export default {
  data() {
    return {
      value: '',
    };
  },
  methods: {
    handleChange(val) {
      this.$emit('change', val);
    },
    handleFocus() {
      const input = document.getElementsByTagName('input')[1];
      input.scrollIntoView(40);
    },
  },
};
</script>
<style lang="less" scoped></style>
